// Glitch Text Effect - ReactBits Style
class GlitchText {
  constructor(element, options = {}) {
    this.element = element;
    this.options = {
      speed: options.speed || 1,
      enableShadows: options.enableShadows !== false,
      enableOnHover: options.enableOnHover || false,
      className: options.className || '',
      ...options
    };
    
    this.init();
  }

  init() {
    // Set data-text attribute for CSS pseudo-elements
    const text = this.element.textContent || this.element.innerText;
    this.element.setAttribute('data-text', text);
    
    // Apply CSS classes
    this.element.classList.add('glitch');
    
    if (this.options.enableOnHover) {
      this.element.classList.add('enable-on-hover');
    }
    
    if (this.options.className) {
      this.element.classList.add(this.options.className);
    }
    
    // Set CSS custom properties
    this.updateStyles();
  }

  updateStyles() {
    const afterDuration = `${this.options.speed * 3}s`;
    const beforeDuration = `${this.options.speed * 2}s`;
  
    const color1 = this.options.color1 || '#ff0040';
    const color2 = this.options.color2 || '#00ffff';
  
    const enableShadows = this.options.enableShadows !== false;
    const afterShadow = enableShadows ? `-2px 0 ${color1}` : 'none';
    const beforeShadow = enableShadows ? `2px 0 ${color2}` : 'none';
  
    this.element.style.setProperty('--after-duration', afterDuration);
    this.element.style.setProperty('--before-duration', beforeDuration);
    this.element.style.setProperty('--glitch-color-1', color1);
    this.element.style.setProperty('--glitch-color-2', color2);
    this.element.style.setProperty('--after-shadow', afterShadow);
    this.element.style.setProperty('--before-shadow', beforeShadow);
  }
  
  // Public methods to update properties
  updateSpeed(speed) {
    this.options.speed = speed;
    this.updateStyles();
  }

  updateShadows(enable) {
    this.options.enableShadows = enable;
    this.updateStyles();
  }

  updateHoverMode(enable) {
    this.options.enableOnHover = enable;
    if (enable) {
      this.element.classList.add('enable-on-hover');
    } else {
      this.element.classList.remove('enable-on-hover');
    }
  }

  updateColors(color1, color2) {
    this.options.color1 = color1;
    this.options.color2 = color2;

    const enableShadows = this.options.enableShadows !== false;
    const afterShadow = enableShadows ? `-2px 0 ${color1}` : 'none';
    const beforeShadow = enableShadows ? `2px 0 ${color2}` : 'none';

    this.element.style.setProperty('--glitch-color-1', color1);
    this.element.style.setProperty('--glitch-color-2', color2);
    this.element.style.setProperty('--after-shadow', afterShadow);
    this.element.style.setProperty('--before-shadow', beforeShadow);
  }
}

// Auto-initialize glitch elements
document.addEventListener('DOMContentLoaded', function() {
  
  // Initialize text glitch elements
  const glitchElements = document.querySelectorAll('[data-glitch-text]');
  glitchElements.forEach(element => {
    // Skip if already initialized
    if (element._glitchInstance) {
      return;
    }
    
    const speed = parseFloat(element.dataset.glitchSpeed) || 1;
    const enableShadows = element.dataset.glitchShadows !== 'false';
    const enableOnHover = element.dataset.glitchHover === 'true';
    const color1 = element.dataset.glitchColor1 || 'red';
    const color2 = element.dataset.glitchColor2 || 'cyan';
    
    const glitch = new GlitchText(element, {
      speed,
      enableShadows,
      enableOnHover
    });
    
    // Apply glitch colors via CSS variables (always)
    glitch.updateColors(color1, color2);

    // Apply per-channel opacity if provided
    const opacity = element.dataset.glitchOpacity;
    const opacity1 = element.dataset.glitchOpacity1;
    const opacity2 = element.dataset.glitchOpacity2;
    if (opacity) element.style.setProperty('--glitch-opacity', opacity);
    if (opacity1) element.style.setProperty('--glitch-opacity-after', opacity1);
    if (opacity2) element.style.setProperty('--glitch-opacity-before', opacity2);
    
    // Store instance for later access
    element._glitchInstance = glitch;
    element.glitchInstance = glitch; // Alternative access
  });

  // Initialize SVG glitch elements with simplified sizing
  const svgGlitchElements = document.querySelectorAll('[data-svg-glitch]');
  svgGlitchElements.forEach(element => {
    // Verificar que el elemento existe
    if (!element) {
      console.warn('SVG element not found');
      return;
    }
    
    element.classList.add('glitch-svg');
    
    // Obtener el tamaño directamente del data attribute
    const sizeValue = element.dataset.svgSize || '200';
                const color = element.dataset.svgColor || '#ffffff';
                const refreshDelay = element.dataset.refreshDelay || '2s';
                const glitchColor1 = element.dataset.glitchColor1 || '#ff0040';
                const glitchColor2 = element.dataset.glitchColor2 || '#00ffff';
    
    // Encontrar el SVG dentro del contenedor (puede ser personalizado o generado)
    const svgElement = element.querySelector('svg');
    if (svgElement) {
      // Aplicar el tamaño exacto al SVG - sin porcentajes
      svgElement.style.width = sizeValue + 'px';
      svgElement.style.height = sizeValue + 'px';
      svgElement.setAttribute('width', sizeValue);
      svgElement.setAttribute('height', sizeValue);
      
      // Remover cualquier estilo que haga que el SVG se ajuste al contenedor
      svgElement.style.display = 'block';
      svgElement.style.maxWidth = 'none';
      svgElement.style.maxHeight = 'none';
      
      // Aplicar color a todos los elementos que puedan usar color
      // Para SVG personalizado, aplicamos currentColor para que sea configurable
      svgElement.style.color = color;
      
      // Para elementos de texto dentro del SVG
      const textElements = svgElement.querySelectorAll('text');
      textElements.forEach(textEl => {
        if (!textEl.style.fill || textEl.style.fill === '' || textEl.style.fill === 'currentColor') {
          textEl.style.fill = color;
        }
      });
      
      // Para paths, circles, rects, etc. que no tengan fill definido
      const shapeElements = svgElement.querySelectorAll('path, circle, rect, ellipse, polygon, polyline, line');
      shapeElements.forEach(shapeEl => {
        if (!shapeEl.style.fill || shapeEl.style.fill === '' || shapeEl.style.fill === 'currentColor') {
          shapeEl.style.fill = color;
        }
        // Forzar que los trazos (líneas) tomen el color configurado
        shapeEl.style.stroke = color;
        if (!shapeEl.getAttribute('stroke-width')) {
          shapeEl.setAttribute('stroke-width', '2');
        }
      });
      
      // Crear una versión base64 del SVG para usar en los pseudo-elementos
      const svgClone = svgElement.cloneNode(true);
      const svgString = new XMLSerializer().serializeToString(svgClone);
      const svgBase64 = btoa(unescape(encodeURIComponent(svgString)));
      
      // Establecer el contenido SVG como atributo para CSS
      element.setAttribute('data-svg-content', svgBase64);
      
      // Aplicar las imágenes de fondo directamente a los pseudo-elementos usando CSS custom properties
      const svgDataUrl = `data:image/svg+xml;base64,${svgBase64}`;
      element.style.setProperty('--svg-background', `url("${svgDataUrl}")`);
      
      // Aplicar colores de glitch personalizados para SVG
-      element.style.setProperty('--svg-glitch-color-1', glitchColor1);
-      element.style.setProperty('--svg-glitch-color-2', glitchColor2);
+      element.style.setProperty('--glitch-color-1', glitchColor1);
+      element.style.setProperty('--glitch-color-2', glitchColor2);
      
      // Eliminar capas de glitch existentes para evitar duplicados
      const existingLayers = element.querySelectorAll('.svg-glitch-layer');
      existingLayers.forEach(l => l.remove());
      
      // Crear capas SVG duplicadas para glitch en líneas (strokes)
      const layer1 = svgElement.cloneNode(true);
      const layer2 = svgElement.cloneNode(true);
      
      // Ajustar tamaño y posicionamiento de las capas
      [layer1, layer2].forEach(layer => {
        layer.setAttribute('width', sizeValue);
        layer.setAttribute('height', sizeValue);
        layer.style.width = sizeValue + 'px';
        layer.style.height = sizeValue + 'px';
        layer.style.position = 'absolute';
        layer.style.top = '0';
        layer.style.left = '0';
        layer.style.pointerEvents = 'none';
      });
      
      // Colorear trazos en cada capa con los colores de glitch
      const layer1Shapes = layer1.querySelectorAll('path, circle, rect, ellipse, polygon, polyline, line');
      layer1Shapes.forEach(el => {
        el.style.stroke = glitchColor1;
        if (!el.getAttribute('stroke-width')) el.setAttribute('stroke-width', '2');
      });
      const layer2Shapes = layer2.querySelectorAll('path, circle, rect, ellipse, polygon, polyline, line');
      layer2Shapes.forEach(el => {
        el.style.stroke = glitchColor2;
        if (!el.getAttribute('stroke-width')) el.setAttribute('stroke-width', '2');
      });
      
      // Aplicar clases para animación via CSS
      layer1.classList.add('svg-glitch-layer', 'layer-1');
      layer2.classList.add('svg-glitch-layer', 'layer-2');
      
      // Insertar las capas encima del SVG base
      element.appendChild(layer1);
      element.appendChild(layer2);
      
      // El contenedor debe ajustarse al SVG, no al revés
      element.style.width = 'auto';
      element.style.height = 'auto';
      element.style.display = 'block';
      element.style.margin = '0 auto';
      
      // Aplicar delay de refresh para las animaciones
      element.style.setProperty('--refresh-delay', refreshDelay);
      
      // Debug log
      console.log('SVG Glitch initialized with custom support:', {
        size: sizeValue + 'px',
        color: color,
        element: element,
        svgElement: svgElement,
        isCustomSVG: !svgElement?.querySelector('text[data-text]')
      });
      }
    });
});

// Global function for manual initialization
window.initGlitchText = function(selector, options = {}) {
  const elements = document.querySelectorAll(selector);
  const instances = [];
  
  elements.forEach(element => {
    const instance = new GlitchText(element, options);
    instances.push(instance);
    element._glitchInstance = instance;
    element.glitchInstance = instance;
  });
  
  return instances.length === 1 ? instances[0] : instances;
};

// Export for module systems
if (typeof module !== 'undefined' && module.exports) {
  module.exports = GlitchText;
}

// Añadir utilidades al prototipo para controlar la animación
GlitchText.prototype.pause = function() {
  this.element.classList.add('paused');
};

GlitchText.prototype.resume = function() {
  this.element.classList.remove('paused');
};

GlitchText.prototype.destroy = function() {
  if (this._observer) {
    try { this._observer.disconnect(); } catch(e) {}
  }
  this.element.classList.remove('glitch', 'enable-on-hover', 'paused', 'reduced-motion');
  this.element.style.removeProperty('--after-duration');
  this.element.style.removeProperty('--before-duration');
  this.element.style.removeProperty('--after-shadow');
  this.element.style.removeProperty('--before-shadow');
  this.element._glitchInstance = null;
  this.element.glitchInstance = null;
};

// Mejorar la auto-inicialización: pausar fuera de viewport y respetar reduced-motion
(function() {
  const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function enhanceGlitchInit() {
    const glitchElements = document.querySelectorAll('[data-glitch-text]');
    glitchElements.forEach(element => {
      const instance = element._glitchInstance || element.glitchInstance;
      if (!instance) return;

      // Respeto de reduced motion si el elemento lo solicita
      const respectReduced = (element.dataset.glitchRespectReduced || 'true') !== 'false';
      if (prefersReduced && respectReduced) {
        element.classList.add('paused', 'reduced-motion');
      }

      // Pausar fuera de viewport si está activado
      const observe = (element.dataset.glitchObserve || 'true') !== 'false';
      if (observe && 'IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              element.classList.remove('paused');
            } else {
              element.classList.add('paused');
            }
          });
        }, { root: null, threshold: 0.1 });
        observer.observe(element);
        instance._observer = observer;
        element._glitchObserver = observer;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceGlitchInit);
  } else {
    enhanceGlitchInit();
  }

  // Soporte para el editor de Shopify: reinicializar al cargar/seleccionar secciones
  document.addEventListener('shopify:section:load', function(e) {
    try {
      const sectionId = e.detail && e.detail.sectionId;
      const section = document.getElementById('shopify-section-' + sectionId);
      if (!section) return;
      const elements = section.querySelectorAll('[data-glitch-text]');
      elements.forEach(el => {
        if (!el._glitchInstance) {
          const speed = parseFloat(el.dataset.glitchSpeed) || 1;
          const enableShadows = el.dataset.glitchShadows !== 'false';
          const enableOnHover = el.dataset.glitchHover === 'true';
          const color1 = el.dataset.glitchColor1 || 'red';
          const color2 = el.dataset.glitchColor2 || 'cyan';

          const glitch = new GlitchText(el, {
            speed,
            enableShadows,
            enableOnHover
          });
          // Always apply colors so CSS variables are set
          glitch.updateColors(color1, color2);
          
          // Apply per-channel opacity if provided
          const opacity = el.dataset.glitchOpacity;
          const opacity1 = el.dataset.glitchOpacity1;
          const opacity2 = el.dataset.glitchOpacity2;
          if (opacity) el.style.setProperty('--glitch-opacity', opacity);
          if (opacity1) el.style.setProperty('--glitch-opacity-after', opacity1);
          if (opacity2) el.style.setProperty('--glitch-opacity-before', opacity2);
          
          el._glitchInstance = glitch;
          el.glitchInstance = glitch;
        }
      });
      enhanceGlitchInit();
    } catch (err) {
      console.warn('GlitchText sección reload error:', err);
    }
  });
})();